import { usePlaceById } from 'hooks/usePlace'
import type { UserPreferenceDestination } from '../types'
import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import SolidBellRingIcon from 'LuxKit/Icons/solid/SolidBellRingIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import Caption from 'LuxKit/Typography/Caption'

export function DisplayItemWithCheckBox({ destination, onClick }: { destination: UserPreferenceDestination, onClick: (item: UserPreferenceDestination) => void }) {
  const place = usePlaceById(destination.placeId, !!destination.name)

  return (<CheckboxInput
    key={`DisplayItemWithCheckBox-${destination.placeId}`}
    onClick={() => onClick(destination)}
    size="large"
    checked
  >
    <BodyTextBlock
      endIcon={destination.isAlertSelected ? <SolidBellRingIcon size="XS" /> : null}
      variant="medium"
      weight="bold"
    >
      {place?.name || destination.name}
    </BodyTextBlock>
    <Caption colour="neutral-three" variant="medium">
      {place?.name || destination.name}
    </Caption>
  </CheckboxInput>)
}
